// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 427) return "427.css";
	// return url for filenames based on template
	return "" + "main" + "." + "e93e566bf3f2533eb333" + ".css";
};